import { createGlobalStyle } from 'styled-components';
// Abstracts
import * as palette from './variables';
import GlacialIndifference from "../fonts/GlacialIndifference-Regular.otf";
import AmsterdamOne from "../fonts/AmsterdamOne.ttf";


export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;500;600;700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Merienda:wght@700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Sacramento:wght@100;200;300;400;500;600&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@100;200;300;400;500;600;700;800&family=Sacramento&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600;700;800&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Sacramento&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Berkshire+Swash&family=Poppins:wght@400;500;700;800;900&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Lacquer:wght@400;700&display=swap');
  
  //Importing Glacial Indifference font
  @font-face {
    font-family: "Glacial Indifference";
    src: url(${GlacialIndifference}) format('opentype');
  }
  //Importing AmsterdamOne font
  @font-face {
    font-family: "amsterdam one";
    src: url(${AmsterdamOne}) format('truetype');
  }

  @-ms-viewport {
  width: device-width;
  }
  html {
  box-sizing: border-box;
  font-size: 13pt;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
  }

  body {
  -ms-overflow-style: scrollbar;
  line-height: 1;
  -webkit-text-size-adjust: none;
  -webkit-font-smoothing: antialiased;
  overflow: hidden;
  background-color: ${palette.APP_BACKGROUND_COLOR} !important;
  }

  html, body, #root {
  width: 100%;
  height: 100%;
  }

  *, *:before, *:after {
  box-sizing: inherit;
  }

  html, body, div, span, applet, object,
  iframe, h1, h2, h3, h4, h5, h6, p, blockquote,
  pre, a, abbr, acronym, address, big, cite,
  code, del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var, b,
  u, i, center, dl, dt, dd, ol, ul, li, fieldset,
  form, label, legend, table, caption, tbody,
  tfoot, thead, tr, th, td, article, aside,
  canvas, details, embed, figure, figcaption,
  footer, header, hgroup, menu, nav, output, ruby,
  section, summary, time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: middle;
  }

  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
  display: block;
  }

  ol, ul {
  list-style: none;
  }

  blockquote, q {
  quotes: none;
  }
  blockquote:before, blockquote:after, q:before, q:after {
  content: none;
  }
  input::-moz-focus-inner {
  border: 0;
  padding: 0;
  }
  input, select, textarea {
  -moz-appearance: none;
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  }
  body, input, select, textarea, button {
  font-family: ${palette.FONT_FAMILY} !important;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.65;
  }
  section {
  position: relative;
  }
  a {
  -moz-transition: color 0.2s ease-in-out;
  -webkit-transition: color 0.2s ease-in-out;
  -ms-transition: color 0.2s ease-in-out;
  transition: color 0.2s ease-in-out;
  text-decoration: underline;
  }
  strong {
  font-weight: 600;
  }
  em {
    font-style: italic;
  }
  h1,h2,h3,h4,h5,h6 {
  line-height: 1.25;
  }

  h1 {
  font-size: 36px;
  }

  h2 {
    font-size: 32px;
  }

  h3 {
    font-size: 26px;
  }

  h4 {
    font-size: 20px;
  }

  img {
    width: 100%;
    display: block;
  }

.custom-download {
  .ant-dropdown-menu-item {
      font-weight: bold;
      font-size: 10px;
      padding: 6px 24px;
      margin: 1px 0px;
      text-wrap: wrap;

      &:hover {
        background: #8C52FF !important;
        color: white;
      }
  }
}

  p {
  font-size: 16px;
  line-height: 1.5;
  }
  .disable-select {
    -webkit-user-select: none;  
    -moz-user-select: none;    
    -ms-user-select: none;      
    user-select: none;
  }
  .cellPaddingPopover {
    .ant-popover-arrow {
      border-color: #25292D !important;
    }
    .ant-popover-inner {
      background: #25292D;
    }
  }
  .moveable-padding {
    cursor: move;
  }
  .contextMenu {
    padding: .5rem 1rem;
    border: 1px solid gray;
    border-radius: 5px;
    background-color: white;
    cursor: pointer;
  }
  .moveable-control-box {
    cursor: all-scroll;
    &.is-dragging {
      .moveable-control {
        opacity: 0 !important;
      }
      .moveable-rotation-line {
        opacity: 0 !important;
      }
    }
    &.hide {
      visibility: hidden;
    }
    > .group-element-selected {
      z-index: 1 !important;
      > .moveable-line {
        border: 1px solid #394edb;
      }
    }
  }

  .moveable-line.moveable-dashed:before {
    background-color: #00c4cc;
    color: #fff !important;
    padding: 0px 5px;
    border-radius: 4px;
  }
  #react-joyride-step-2, #react-joyride-step-3, #react-joyride-step-4, #react-joyride-step-5 {
    .__floater__arrow {
      left: -84px !important;
    }
  }
  .app_tour_close_animation {
      animation: fadeOut 0.3s ease forwards !important;
      @keyframes fadeOut {
        from {
          opacity: 1;
        } to {
          opacity: 0;
        }
      }
    }
  #react-joyride-step-0 {
    .__floater.__floater__open {
      animation: scaleUp 0.3s ease forwards;
      @keyframes scaleUp {
        from {
          opacity: 0;
          transform: translate(-50%, -50%) scale(0);
        } to {
          opacity: 1;
          transform: translate(-50%, -50%) scale(1);
        }
      }
    }
    .app_tour_close_animation {
      animation: scaleDown 0.3s ease forwards !important;
      @keyframes scaleDown {
        from {
          opacity: 1;
          transform: translate(-50%, -50%) scale(1);
        } to {
          opacity: 0;
          transform: translate(-50%, -50%) scale(0);
        }
      }
    }
  }
  .date-var-tooltip .ant-tooltip-content {
    transform: translateY(14px) !important;
  }

  .moveable-line {
    border: 1px solid #00c4cc;
    background: transparent !important;
  }

  .moveable-control {
    width: calc(12 * var(--zoompx)) !important;
    height: calc(12 * var(--zoompx)) !important;
    margin-top: calc(-6 * var(--zoompx)) !important;
    margin-left: calc(-6 * var(--zoompx)) !important;
    background: #fff !important;
    box-shadow: 0 0 5px 1px rgb(57 76 96 / 15%), 0 0 0 1px rgb(53 71 90 / 20%);
    opacity: 1;
    &.moveable-e, &.moveable-w {
      width: 4px !important;
      border-radius: 6px !important;
      left: 4px !important;
      height: 16px !important;
    }
    &.moveable-rotation {
      box-shadow: none !important;
    }
    &.moveable-rotation-control {
      box-shadow: none !important;
      border-color: #00c4cc !important;
    }
  }

  .moveable-rotation-line {
    opacity: 1;
  }

  .moveable-line.moveable-rotation-line .moveable-control {
    border-color: #00c4cc !important;
  }

  .moveable-label {
    position: fixed;
    top: 0;
    left: 0;
    padding: 5px;
    border-radius: 5px;
    background: #333;
    z-index: 100000;
    color: #fff;
    font-weight: bold;
    font-size: 12px;
    display: none;
    transform: translate(-100%, -100%);
  }

  .controls-with-opacity {
    .moveable-ne, .moveable-sw, .moveable-se, .moveable-w {
      opacity: 0 !important;
    }
  }

  .line-element-controls {
    .moveable-control {
      &.moveable-e, &.moveable-w {
        width: calc(12 * var(--zoompx)) !important;
        height: calc(12 * var(--zoompx)) !important;
        border-radius: 50% !important;
        left: 0px !important;
      }
    }
    .moveable-line {
      &.moveable-direction, &.moveable-horizontal {
        opacity: 0;
      }
    }
    .moveable-rotation-line {
      opacity: 1;
    }
  }

  .mailRoomTagsFilter{
    .ant-select-dropdown {
      border-radius: 16px !important;
    }
    .ant-select-dropdown-menu{
      padding: 10px 16px !important;
      ::-webkit-scrollbar {
        display: none; /* Safari and Chrome */
      }      
      font-family: Open Sans, sans-serif !important;
    }
    .ant-select-dropdown-menu-item-group-list {
      display: flex !important;   
      flex-wrap: wrap;
      height: 95%;
    }
    .anticon.anticon-check.ant-select-selected-icon {
      display: none !important;
    }
    .ant-select-dropdown-menu-item {
      margin-block: 6px;
      margin-right: 6px;
      padding: 5px 10px !important;     
      border-radius: 15px !important; 
      background: #afafaf;
      color: #fff !important;      
      font-size: 12px !important;
      letter-spacing: 0.25px !important;
    }
    .ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled){
      background: #afafaf !important;
      color: #fff !important;
    }
    .ant-select-dropdown-menu-item:hover, .ant-select-dropdown-menu-item:focus{
      background: #afafaf !important;
      color: #fff !important;
    }
    .ant-select-dropdown-menu-item-selected:hover, .ant-select-dropdown-menu-item-selected:focus{
      background: #ffd45a !important;
      color: #000 !important;
    }
    .ant-select-dropdown-menu-item.ant-select-dropdown-menu-item-selected {
      background: #ffd45a !important;
      color: #000 !important;
    }
    .ant-select-dropdown-menu-item-group-title {
      font-size: 0.9rem;
      line-height: 28px;
      text-transform: uppercase;
      font-weight: 600;
      letter-spacing: 1px;
      padding-left: 0;
      color: #000;
    }
    .ant-select-dropdown-menu-item-disabled {
      color: rgba(0, 0, 0, 0.25);
      cursor: not-allowed;
      position: absolute;
      top: 0;
      width: 90%;
      height: 90%;
      z-index: 20000;
      background: #fff;
    }
    .ant-select-dropdown-menu-item-disabled:hover{
      background: #fff !important;
    }
  }

  .ant-select-selection--multiple {
    min-height: 35px;
    max-height: 200px !important;
    overflow: auto;
    ::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
  }
  .ant-select-tree-treenode-selected {
    display: none !important;
  }
  .ant-select-tree-dropdown {   
    min-width: 301px !important;
    ::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
  }
  .ant-select-selection--multiple .ant-select-selection__placeholder {
    margin-top: -6px;
  }
  .ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner,
  .ant-select-tree-checkbox-indeterminate .ant-select-tree-checkbox-inner::after {
    background: linear-gradient(to right, #ef9d43, #e75516);
    border: 1px solid rgb(219, 57, 31) !important;
  }
  .ant-select-tree-checkbox:hover .ant-select-tree-checkbox-inner{
    border: 1px solid rgb(219, 57, 31) !important;
  }
  .ant-select-tree-checkbox-checked .ant-select-tree-checkbox-inner {
    background: linear-gradient(to right, #ef9d43, #e75516);
  }
  .ant-select-tree {
    padding-right: 25px !important;
  }
  .ant-notification{
    width: 65px;    
  }  

  .ant-notification-topLeft {    
    z-index: 30001;
    margin: 0;
    top: 0 !important;
    border-radius: 0;
  }

  .ant-notification-notice.ant-notification-notice-closable.generateAIContent {
    height: 100vh;
    width: 100vw;
    margin: 0;
    backdrop-filter: blur(0px);
    background-color: rgba(2, 2, 2, 0.55);    
    display: flex;
    align-items: center;
    justify-content: center;
    .ant-notification-notice-content {
      margin: 0;
      background: #fff;
      padding: 125px 100px;
    }
    .ant-notification-notice-close {
      display: none;
    }
    .ant-notification-notice-message {
      padding-right: 24px;
      width: 100% !important;
    }
  }

  .ant-notification-notice.ant-notification-notice-closable.storageNotificationInfo {
    width: 100%;
    margin-left: auto;
    text-align: center;
    padding: 15px 0 0px 0;
    background: #c81919;
    border-radius: 15px;    
    .ant-notification-notice-with-icon .ant-notification-notice-message {
      margin: 0;
      padding: 0;
    }
    .anticon.ant-notification-notice-icon-error {
      display: none !important;
    }
    .ant-notification-close-icon{
      display: none !important;
    }   
    .ant-notification-notice-with-icon .ant-notification-notice-message {
    margin-bottom: 4px;
     margin-left: 0;
    }
  }

  .ant-notification-notice.ant-notification-notice-closable.storageNotification.close {
    display: none !important;
  }

  .ant-notification-notice.ant-notification-notice-closable.storageNotification {
    margin-left: 0 !important;
    width: 475px !important;
    padding: 15px 0;
    border-top: 10px solid red;
    position: absolute;
    right: 2%;
    .ant-notification-notice-content {
      height: 100%;
      font-family: Montserrat,sans-serif;
    }
    .ant-notification-notice-with-icon .ant-notification-notice-message {
      font-size: 11px;
      color: #000;
      font-weight: 600;
      letter-spacing: 1px;
      padding: 0 25px;
      margin: 0;
    }
    .ant-notification-notice-with-icon .ant-notification-notice-description {
      margin: 0;
      padding: 0;
      width: 100%;
      .err_desc {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 10px 0;
      }
      p {    
        font-size: 13px;
        color: #000;
        margin: 0 12px;
      }
      a {
        color: #000;
        font-weight: 700;
      }
      a:hover {
        color: #000;
      }
      button.ant-btn {
        background: #000 !important;
        border: transparent;
        border-radius: 12px;
        color: #fff;
        text-transform: uppercase;
        font-size: 11px;
        font-weight: 700;
      }
      .ant-btn[disabled] {
        color: rgba(0,0,0,0.25) !important;
        background-color: #f5f5f5 !important;
        cursor: not-allowed !important;
    }
    }
    .ant-notification-notice-with-icon {
      display: flex;
      flex-direction: column;
      height: 100%;
      align-items: center;
      justify-content: center;
    }
    .anticon.ant-notification-notice-icon-error {
      display: none;
    }
  }

  .ant-notification-notice.ant-notification-notice-closable.mailRoom{
    margin-left: 25% !important;
    width: 80%;
  }

  .checkBox_tooTip{
    .ant-tooltip-inner {
      min-height: 225px !important;
      min-width: 325px !important;
      height: 225px !important;
      width: 325px !important;
      background: #b3b3b3 !important;
    }
  }
  .ant-radio-checked .ant-radio-inner{
    border-color: #000;
  }
  .ant-radio-inner::after {
    background-color: #000;
  }
  .ant-radio-checked::after {
    border: 1px solid #000;
  }
  .ant-radio-wrapper:hover .ant-radio, 
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-input:focus + .ant-radio-inner {
    border-color: #000;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #000 !important;
    border-color: #000 !important;
  }
  .ant-checkbox-checked::after {
    border: 1px solid #000 !important;
  }
  .ant-notification.ant-notification-bottomLeft{
    z-index: 10 !important;
  }
  .ant-notification-notice.ant-notification-notice-closable {
    margin-left: 50%;
    width: 75%;
    @media only screen and (max-width: 1460px) {
      margin-left: 15% 
    }
  }
  .ant-notification-close-icon {
    position: absolute;
    right: 0;
  }
  .ant-message{
    font-weight: 500;
    z-index: 100000 !important;

  }

   /* .ant-message {
    top: 0px !important;
    font-size: 14px !important;
    font-weight: 500;
    z-index: 100000 !important;
    .ant-message-notice {
      margin: 0px !important;
      padding: 0px !important;
    }
    .ant-message-notice-content {
      padding: 0px;
    }
    .ant-message-custom-content {
      padding: 20px;
      &.ant-message-error {
        background-color: #D84A49;
        color: #fff;
        .anticon {
          color: #fff;
        }
      }
      &.ant-message-success {
        background-color: #2ECD71;
        color: #fff;
        .anticon {
          color: #fff;
        }
      }
      &.ant-message-warning {
        background-color: #FFCC00;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        .anticon {
          color: #fff;
        }
      }
    }
  }  */
  .ant-switch{
    background-color:#dbd9d9 !important;
  }
  .ant-switch-checked {
    background-color:#b1272c !important;
  }
  .ant-empty.ant-timeline-item-last.ant-timeline-item-left {
    margin: 0 !important;
  }
  .ant-empty {
    margin-top: 200px !important;
    .empty-description {
      opacity: 0.6;
    }
  }

.react-resizable {
    position: relative;
    background-clip: padding-box;
  }
  
 .react-resizable-handle {
    position: absolute;
    width: 10px;
    height: 100%;
    bottom: 0;
    right: -5px;
    cursor: col-resize;
    z-index: 1;
  }

  .ant-popover {
    z-index: 10500 !important;
  }

  .ant-popover-title {
    font-size: 16px !important;
    font-weight: bold !important;
    padding: 8px 12px ;
  }

  .ant-popover-inner-content {
    padding: 15px !important;
  }

  .ant-popover-buttons {
    text-align: center !important;
    .ant-btn{
      background:#000 !important;
      background-color:#000 !important;
      border-color:#000 !important;
      color:#fff !important;
      width: 70px;
      border-radius: 15px;
    }
  }
  .ant-table-filter-dropdown {
    min-width: 220px !important;
    min-height: 120px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .ant-table-filter-dropdown-btns {
    width: 100%;
    padding: 10px 8px !important;
    overflow: hidden;
    border-top: 1px solid #e8e8e8 !important;
    display: flex;
    justify-content: center;
  }
  .ant-table-filter-dropdown-link {
    color: #fff !important;
    min-width: 65px;
    width: fit-content;
    padding: 0px 5px;
    height: 25px;
    font-size: 12px;
    margin-left: 5px;    
    margin-right: 5px;
    background: #000;
    text-decoration: none;
    display: flex;
    align-items: center;
    border-radius: 15px;
    justify-content: center;
  }
  .cell-options {
    .cell-item {
      font-size: 14px;
      color: rgb(23, 43, 77);
      padding: 8px 12px 7px;
      &:hover {
        background-color: rgb(244, 245, 247);
        color: rgb(23, 43, 77);
        fill: rgb(244, 245, 247);
        cursor: pointer;
      }
    }
  }

  .ant-table-thead > tr > td, .ant-table-tbody > tr > td {
    position: relative !important;
  }

  .ant-table-tbody > tr > td {
    background-color: #fff;
  }
  .ant-select-dropdown {
    z-index: 10500 !important;
    min-width:100px!important
  }

  .ant-select-dropdown-menu-item {
    font-size: 14px !important;
    padding: 8px 12px !important;
    font-weight: 600 !important;
    color: rgb(14 19 24 / 0.5) !important;
    &:hover, &:focus {
      background-color: rgba(14,19,24,0.07) !important;
      color: rgb(14 19 24 / 0.7) !important;
    }
  }
  .ant-select-dropdown-menu-item.variableOption {
    display: flex !important;
    flex-direction: row;
    justify-content: space-between;
    .variableType {
      color: #fff;
      font-size: 10px;
      background: #b1272c;
      border-radius: 30px;
      height: 20px;
      width: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .ant-select-dropdown-menu-item.comboOption.ant-select-dropdown-menu-item-selected {
    background-color: #74b9d7 !important;
    font-weight: normal !important;
    padding: 5px !important;
  }
  .ant-select-dropdown-menu-item.comboOption {
    font-weight: normal !important;
    padding: 5px !important;
  }
  .ant-select-dropdown-menu-item-selected {
    font-size: 14px !important;
    font-weight: bold;
    color: #0e1318 !important;
  }
  .ant-dropdown-menu-item-selected {
    color: #000 !important;
    background-color: #dfdfdf !important;
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner, 
  .ant-checkbox:hover .ant-checkbox-inner, 
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #000 !important;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #000 !important;
    border-color: #000 !important;
  }
  .ant-dropdown-menu-item:hover {
    background-color: #dfdfdf !important;
  }
  .ant-dropdown {
    z-index: 10500 !important;
  }
  .ant-tooltip {
    z-index: 10600 !important;
  }
  .ant-slider-tooltip{
    z-index:10501!important;
  }
  .ant-tooltip-inner {
    background-color: #000 !important;
  }
  .blockingAutoSave {
    .ant-tooltip-inner {
      border-radius: 16px;
      background-color: #FFDE59 !important;
      color: #000;
    }
  }
  .ant-tooltip.custom-purple-tooltip, .ant-tooltip.custom-yellow-tooltip {
    .ant-tooltip-arrow:before {
      height: 10px;
      width: 10px;
      background-color: #FFDE59;
    }
    .ant-tooltip-inner {
      font-size: 17px;
      border-radius: 16px;
      background-color: #FFDE59 !important;
      color: #000;
      max-width: 210px;
    }
  }
  .ant-tooltip.custom-purple-tooltip {
    .ant-tooltip-arrow:before {
      background-color: #8C52FF;
    }
    .ant-tooltip-inner {
      background-color: #8C52FF !important; 
      max-width: 156px;
      color: #fff;
    } 
  }
  .ant-tooltip.nav-tooltip {
    .ant-tooltip-inner {
      padding: 16px;
    }
  }
  .ant-tooltip.widget-tooltip {
    .ant-tooltip-inner {
      padding: 16px;
      max-width: 100px;
    }
  }
  .dummy-widget {
    position: fixed;
    right: 20px;
    bottom: 20px;
    height: 60px;
    width: 60px;
  }
  .language-tag {
    background: cadetBlue;
    color: #fff;
    display: grid;
    place-items: center;
    margin-left: 8px;
    padding: 2px 6px;
    line-height: normal;
    font-weight: 900;
    letter-spacing: 0.5px;
    font-size: 13px;
  }
  .ant-calendar-range-right .ant-calendar-date-input-wrap,
  .ant-calendar-range-left .ant-calendar-date-input-wrap{
    margin-left: 100px !important;
  }
  .ant-calendar-range-middle {
    left: 68% !important;
  }
  .ant-calendar-range .ant-calendar-selected-start-date .ant-calendar-date,
  .ant-calendar-range .ant-calendar-selected-end-date .ant-calendar-date {
    background: rgb(177, 39, 44) !important;
    color: #fff !important;
  }
  .ant-calendar-today .ant-calendar-date {
    color: rgb(177, 39, 44) !important;
    font-weight: bold;
    border-color: rgb(177, 39, 44) !important;
  }
  .ant-calendar-range .ant-calendar-in-range-cell::before {
    background: rgb(251 226 227) !important;
    color: #fff !important;
  }
  .ant-calendar-date:hover{
    background: rgb(251 226 227) !important;
    color: #fff !important;
  }
  .ant-calendar-ok-btn{
    display: none;
  }
  a.ant-calendar-time-picker-btn {
    color: #000 !important;
    font-weight: 700;
  }
  .complexDateVar {
    left: 275px !important;
    .ant-calendar-selected-day .ant-calendar-date {
      background: rgb(177,39,44) !important;
      color: #fff !important;
    }
    .ant-calendar-input {
      font-size: 14px;
      text-align: center;
    }
  }
  .ant-modal {
    padding: 24px !important;
  }
  .ant-modal-mask, .ant-modal-wrap {
    z-index: 10000 !important;
  }
  .ant-modal-mask {
    backdrop-filter: blur(10px) ;
    background-color: rgb(2 2 2 / 55%);
  }
  .ant-modal-header {
    border-bottom: initial !important;
    padding: 30px 34px !important;
    text-align: center;
  }
  .ant-modal-title {
    font-size: 18px;
    color: #0e1318 !important;
    font-weight: 500;
    text-transform: uppercase;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .ant-modal-content {
    border-radius: 8px !important;
  }
  // .ant-modal-body {
  //   padding: 34px !important;
  // }

  .ant-modal.right-aligned-modal {
    border-radius: 45px 0 0 45px;
    padding: 0 !important;
    position: fixed;
    right: 0;
    top: 50% !important;
    transform: translateY(-50%);
    overflow: hidden;
  }

  .ant-modal.saml-modal{
    .ant-modal-header{
      padding: 10px 0px 10px !important;
      border-bottom: 1px solid #e8e8e8 !important;
    }
  }

  .ant-modal.approvalModal{
    .ant-modal-footer {
      padding-bottom: 30px !important;
    }
    .ant-modal-content{
      height: 100%;
    }
    .ant-modal-header{
      padding: 30px 0px 0px !important;
    }
    .ant-modal-body{
      padding: 0 15px 10px 0 !important;
      @media (max-width: 980px) {
        height: 550px;
      }
    }
    .ant-modal-title{
      font-size:24px
    }
  }
  
   .ant-modal.batchRejection {
     position: absolute;
     top: auto;
     right: 3%;    
     width: 40%;
     backdropFilter: blur(5px);

    .ant-modal-body{
      padding: 15px !important;
    }

    @media only screen and (max-width: 998px) {
     position: absolute;
     top: 50%;
     left: 55%;
     transform: translate(-50%, -50%);
      width:80%
    }

    @media only screen and (min-width: 2000px) { 
     top: 35%;
    }

    .ant-modal-title {
      font-size: 18px !important;
}
  };

 .ant-modal.job-queue {
  .ant-modal-body{
      padding: 0 15px 30px 15px !important;
  };
   .ant-modal-title {
     font-size: 22px !important;
  };
  }
  .ant-collapse .ant-collapse-item.approvla-collapse-panel{
    .ant-collapse-header{
     padding: 5px 16px 5px 40px !important;
     font-size: 18px;
    }
    .ant-collapse-content-box{
    padding: 0px 0px 0px 30px !important
    }
  }

  .image-modal{
    .ant-modal-body{
      padding: 20px !important;
      text-align:end !important;
    }    
  }
  .login-page{
    .label{
      margin-top:10px
    }
  }
  .forceSave-modal.ant-modal {
    .ant-modal-body {
      padding: 0 !important;
    }
  }
  .signup-page{
    .ant-modal-body{
      padding:0px 34px 25px 34px !important;
    }
    .ant-modal-footer{
      padding-top:0px !important;
      padding-bottom:38px !important;
    }
    .label{
      margin-top:10px
    }
  }

  .ant-modal-footer {
    border-top: initial !important;
    padding:34px !important;
    padding-top: 5px !important;
    padding-bottom: 50px !important;
    text-align: center !important;
    .ant-btn {
      text-transform: uppercase;
      font-size: 12px;
      font-weight: 500;
      height: 40px;
      border: 2px solid transparent;
      border-radius: 4px;
      cursor: pointer;
      margin: 0;
      padding: 0 16px;
      color: #0e1318;
      background-color: rgba(64,87,109,.07);
      min-width: 35%;
      border-radius:20px;
      transition: background-color .1s linear,border-color .1s linear,color .1s linear;
      &:first-child {
        margin-right: 8px;
      }
      &:hover,
      &:focus {
        background-color: rgba(57,76,96,.15);
        border-color: transparent;
        box-shadow: initial;
        color: #0e1318;
      }
    }
    .ant-btn-primary {
      background-color: rgb(219 57 31 / 85%);
      color: #ffffff;
      &:hover,
      &:focus {
        background-color: rgb(219 57 31 / 95%);
        color: #ffffff;
      }
    }
  }
  .custom-select-dropdown {
    > div {
      ul li.ant-select-dropdown-menu-item {
        padding: 8px !important;
      }
    }
  }
  .ant-modal-footer .ant-btn:first-child{
    color: #fff !important;
    background: #000 !important;
  }
  .ant-modal-footer .ant-btn-primary {
    color: #fff !important;
    background: #000 !important;
    min-width: 35%;
    border-radius:20px;
}
  .ant-modal-close {
    top: -5px !important;
    right: -5px !important;
  }
  .ant-modal-close-x {
    font-size: 22px !important;
  }
  .imageUpoad-modal.ant-modal {
    .ant-modal-header {
      background: #fff !important;
      padding-bottom: 0 !important;
    }
    .ant-modal-title {
      align-items: flex-start !important;
    }
    .ant-modal-body {
      padding: 20px 34px !important;
    }
    .ant-modal-content {
      background: #fff !important;
    }
  }
  
  .deleteConfirm-modal.ant-modal {
    .ant-modal-body {
      padding: 20px 34px !important;
    }
    .ant-modal-footer .ant-btn.cancel {
      background: #939393 !important;
      font-weight: 700;
    }
    .ant-btn.delete.ant-btn-primary {
      background: rgb(245, 34, 45) !important;
      font-weight: 700;
    }
  }

  .clientList-modal.ant-modal {
    .ant-modal-footer .ant-btn.cancel {
      background: #dedede !important;                
    }
    .ant-modal-footer .ant-btn.confirm {
      background: #ffeb3b !important;           
    }      
    .ant-modal-footer .ant-btn{
     font-weight:600 !important; 
     color:black !important;     
      text-transform: none; 
      font-size: 14px;    
    }
  }


  .design_modal.ant-modal {
      padding: 0 !important; 
      .ant-modal-header {
        border-radius: 8px !important;
      }
      .ant-modal-content {
        background-color: #fff;
        box-shadow:none !important;
        animation: none !important;
      }
    .ant-modal-body {
      padding:0px !important;
    } 
  }

  .templates-list {
    .ant-modal-body {
      padding-top : 0px !important;
    } 
  }

.showContent.ant-modal {
  padding: 0px !important; 
  .ant-modal-body {
    background-color:transparent;
    padding:0px !important;
  } 
}
.mailRoomDoc_modal.ant-modal {
  padding: 0 !important;
  .ant-table-filter-dropdown {
    font-family: 'Montserrat' !important;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #50BE77 !important;
    border-color: #50BE77 !important;
  }
  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background: #50BE77 !important;
  }
  .ant-modal-close-x {
    font-size: 16px !important;
    line-height: 48px;
    width: unset;
    padding-right: 10px;
  }
  .ant-modal-close-x:hover {
    color: #ff4d4d;
    transform: scale(125%);
    transition: transform 300ms ease;
  }
  .ant-modal-content {
    overflow: hidden;
    border-radius: 18px !important;
  }
  .ant-modal-body {
    padding: 0 !important;
    background: #f3f3f3 !important;
    border-radius: 8px !important;
    height: 100%;
  }
  .ant-modal-footer {
    padding: 0 !important;
  }
}
.permission_modal.ant-modal {
  padding: 0 !important; 
  .ant-modal-body {
    padding: 20px !important;
    padding-top: 0 !important;
    text-align:center;
    // border: 1px solid #d9d9d9;
    margin: 20px;
    margin-top: 0px;
    border-radius: 4px;
  } 
  .ant-modal-header {
    padding: 25px !important;
  }
}
.audit_modal.ant-modal {
  padding: 0 !important; 
  .ant-modal-header {
    border-radius: 8px !important;
  }
  .ant-modal-content {
    background-color: #fff;
    box-shadow:none !important;
    animation: none !important;
  }
  .ant-modal-body {
    padding:0px !important;
    overflow: hidden;
    background: #f3f3f3;
    border-radius: 15px;
    height: 600px;
    display: flex;
    justify-content: center;
  } 
}
.ant-tooltip.purple-tooltip {
  .ant-tooltip-arrow:before {
    background-color: #d6bbfb;
  }
  .ant-tooltip-inner {
    background-color: #d6bbfb !important;
    color: black;
    font-weight: bold;
  }
}
.ant-popover.chart-vertical-popover {
  .ant-popover-inner-content {
    padding: 12px 0px !important;
  }
}
.ant-popover.chart-hor-popover {
  .ant-popover-inner-content {
    padding: 8px !important;
  }
}
.attachment_modal.ant-modal {
  padding: 0 !important; 
  .ant-modal-header {
    border-radius: 8px !important;
  }
  .ant-modal-content {
    background-color: #fff;
    box-shadow:none !important;
    animation: none !important;
  }
  .ant-modal-body {
    padding:20px !important;
    overflow: hidden;
  } 
}
.faxConfig_modal.ant-modal {
  .ant-modal-body {
    padding:34px !important;
    padding-top:0 !important;
    padding-bottom:0 !important;
    overflow: hidden;
    background: #fff;
  } 
  .ant-modal-header {
    padding: 25px ​34px !important;
    background: #fff;
  }
  .ant-modal-footer {
    padding: 50px !important;
    background: #fff;
    .ant-btn {
      width: 25% !important;
    }
  }
}
.design_modal_categ.ant-modal{
  width: 530px;
  left: 100px;  
  @media only screen and (min-width: 1460px) {
    left: 200px;  
  }
  .ant-modal-close-x {
    color: #fff;
  }
  .ant-modal-header {
    padding: 15px !important;      
    color:#fff;
    font-size:14px;
    font-weight:500;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    background:rgb(37,41,45)!important;
    p{
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .ant-modal-body {
    background:rgb(37,41,45) !important;
    padding-top: 0px !important;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
  }
}
.static-table-border-options {
  background: #2e3338 !important;
  .ant-dropdown-menu-item {
    color: #fff;
    &:hover {
      background: #BB3024 !important;
    }
    .anticon {
      font-size: 18px !important;
    }
  }
}
.complex-elements-tab-dropdown {
  .ant-dropdown-menu {
    min-width: 100px;
  }
  .ant-dropdown-menu-item {
    font-weight: bold;
    font-size: 14px;
    padding: 6px 12px;
    margin: 1px 0px;
  }
}
.complex-channels-tab-dropdown {
    max-height: 350px;
    overflow-y: scroll;
}
.static-table-alignment-options {
  .ant-popover-arrow {
    border-top-color: #2e3338 !important;
    border-left-color: #2e3338 !important;
  }
  .ant-popover-inner-content {
    background: #2e3338;
  }
  .ant-btn {
    background: transparent;
    color: #fff;
    &:hover {
      background: #BB3024;
      color: #fff;
      border: 1px solid #fff;
    }
  }
  .alignment-options {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    h4 {
      font-size: 14px;
      text-transform: uppercase;
      color: #00c4cc;
    }
  }
}

  .ant-tooltip-inner {
    text-align: center !important;
  }
  .ant-btn[disabled]  {
    color: rgba(0, 0, 0, 0.25) !important;
    background-color: #f5f5f5 !important;
    cursor: not-allowed !important; 
  }
  .ant-select-dropdown-menu-item {
    color: #222222 !important;
  }
  .varUpload{
    .anticon {
      margin-right: 5px;
    }
    .ant-upload {
      font-size: 12px !important;
      color: #000;
      text-transform: uppercase;
      cursor: pointer;
      display: flex;
      align-items: center;
    }
  }
  .dkvUpload{
    .anticon {
      margin-right: 5px;
    }
    .ant-upload {
      font-size: 12px !important;
      color: #000;
      text-transform: uppercase;
      cursor: pointer;
      display: flex;
      align-items: center;
      height: 100%;
      width: 100%;
    }
  }
  .ant-select-dropdown-menu-item {
    .ant-empty {
      margin: 75px 0px !important;
    }
  .ant-upload.ant-upload-drag{
    width: 70% !important;
    background: transparent !important;
  }
  .ant-upload-text{
    color: white !important;
    margin: 0 30px !important;
  }
  .warning-modal.ant-modal {
    .ant-modal-body {
      padding: 20px 34px !important;
    }
  }
  .signup-container{
    .ant-modal-body{
      padding:0px !important;
    }
  }
.glacial{
  font-family:glacial indifference;
}
}
.timelinePopover .ant-popover-inner-content {
  max-width: 250px;
  font-family: Lato;
  max-height: 200px;
  overflow: auto;
  p {
    font-size: 11px;
  }
  .popoverHeading {
    padding-block: 6px;
    font-weight: bold;
    text-decoration: underline;
    text-underline-position: under;
  }
  .userEmails {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    p {
      fontSize: 11px;
      background: #cceeff;
      padding: 3px 7px;
      border-radius: 8px;
    }
  }
}
`;
